module.exports = __webpack_public_path__ + "static/media/printStep5.c10a13b2.png";